import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=0b36744d"
import script from "./Body.vue?vue&type=script&setup=true&lang=js"
export * from "./Body.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports